import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClockComponent } from './clock/clock.component';
import { AdminComponent } from './admin/admin.component';
import { ContactusComponent } from './contactus/contactus.component';
import { HomeComponent } from './home/home.component';
import { InsertMarcaComponent } from './insertMarca/insertMarca.component';
import { LoginComponent } from './login/login.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ResponsabilityComponent } from './responsability/responsability.component';
import { TermsComponent } from './terms/terms.component';
import {
  IsLoggedInGuard,
  IsntLoggedInGuard,
} from './_guards/authGuard.service';
import { JoiaComponent } from './joia/joia.component';
import { InsertProductComponent } from './insertProduct/insertProduct.component';
import { InsertNewsComponent } from './InsertNews/InsertNews.component';
import { InsertCarouselComponent } from './insertCarousel/insertCarousel.component';
import { ServicosComponent } from './servicos/servicos.component';
import { RegisterComponent } from './register/register.component';
import { SomosComponent } from './somos/somos.component';
import { InsertDestaquesComponent } from './insertDestaques/insertDestaques.component';
import { MarcaComponent } from './marca/marca.component';
import { ModeloComponent } from './modelo/modelo.component';
import { SinglenewsComponent } from './singlenews/singlenews.component';
import { RecoveryComponent } from './recovery/recovery.component';
import { ContrastariaComponent } from './contrastaria/contrastaria.component';
import { EmailRecoveryComponent } from './emailRecovery/emailRecovery.component';
import { NoivasComponent } from './noivas/noivas.component';
import { ProdutosComponent } from './produtos/produtos.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { PasswordComponent } from './password/password.component';
import { AcessoriosComponent } from './acessorios/acessorios.component';
import { GestaoComponent } from './gestao/gestao.component';
import { GestaoAltaRelojoariaComponent } from './GestaoaltaRelojoaria/altaRelojoaria.component';
import { GestaoRelojoariaComponent } from './Gestaorelojoaria/relojoaria.component';
import { GestaoJoiasComponent } from './Gestaojoias/joias.component';
import { GestaoNoivasComponent } from './gestaoNoivas/gestaoNoivas.component';
import { GestaoAcessoriosComponent } from './gestaoAcessorios/gestaoAcessorios.component';
import { GestaoPratasComponent } from './gestaoPratas/gestaoPratas.component';
import { GestaoMarcasComponent } from './gestaoMarcas/gestaoMarcas.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'admin',
    children: [
      { path: '', component: AdminComponent, canActivate: [IsntLoggedInGuard] },
      {
        path: 'marcas',
        component: InsertMarcaComponent,
        canActivate: [IsntLoggedInGuard],
      },
      {
        path: 'produtos',
        component: InsertProductComponent,
        canActivate: [IsntLoggedInGuard],
      },
      {
        path: 'noticias',
        component: InsertNewsComponent,
        canActivate: [IsntLoggedInGuard],
      },
      {
        path: 'carousel',
        component: InsertCarouselComponent,
        canActivate: [IsntLoggedInGuard],
      },
      {
        path: 'funcionarios',
        component: RegisterComponent,
        canActivate: [IsntLoggedInGuard],
      },
      {
        path: 'destaques',
        component: InsertDestaquesComponent,
        canActivate: [IsntLoggedInGuard],
      },
      {
        path: 'gestao',
        component: GestaoComponent,
        canActivate: [IsntLoggedInGuard],
      },
      {
        path: 'gestaoMarcas',
        children: [
          {
            path: 'alta',
            component: GestaoAltaRelojoariaComponent,
            canActivate:[IsntLoggedInGuard],
          },
          {
            path: 'relojoaria',
            component: GestaoRelojoariaComponent,
            canActivate:[IsntLoggedInGuard],
          },
          {
            path: 'joias',
            component: GestaoJoiasComponent,
            canActivate:[IsntLoggedInGuard],
          },
          {
            path: 'noivas',
            component: GestaoNoivasComponent,
            canActivate:[IsntLoggedInGuard],
          },
          {
            path: 'acessorios',
            component: GestaoAcessoriosComponent,
            canActivate:[IsntLoggedInGuard],
          },
          {
            path: 'pratas',
            component: GestaoPratasComponent,
            canActivate:[IsntLoggedInGuard],
          },
          {
            path: '',
            component: GestaoMarcasComponent,
            canActivate:[IsntLoggedInGuard],
          }
        ]
      }
    ],
  },
  { path: 'contactus', component: ContactusComponent },
  { path: 'login', component: LoginComponent, canActivate: [IsLoggedInGuard] },
  { path: 'terms', component: TermsComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'responsability', component: ResponsabilityComponent },
  {
    path: 'clock',
    children: [
      { path: '', component: ClockComponent },
      {
        path: 'marca',
        children: [
          { path: '', component: MarcaComponent },
          { path: 'modelo', component: ModeloComponent },
        ],
      },
    ],
  },
  {
    path: 'marca',
    children: [
      { path: '', component: MarcaComponent },
      { path: 'modelo', component: ModeloComponent },
    ],
  },
  { path: 'servicos', component: ServicosComponent },
  { path: 'somos', component: SomosComponent },
  { path: 'recovery', component: RecoveryComponent },
  { path: 'contrastaria', component: ContrastariaComponent },
  { path: 'emailRecovery', component: EmailRecoveryComponent },
  { path: 'noivas', component: NoivasComponent },
  {
    path: 'produtos',
    children: [
      { path: '', component: ProdutosComponent },
      { path: 'modelo', component: ModeloComponent },
      { path: '**', redirectTo: '' },
    ],
  },
  {
    path: 'noticias',
    children: [
      { path: '', component: NoticiasComponent },
      { path: 'item', component: SinglenewsComponent },
      { path: '**', redirectTo: '' },
    ],
  },
  { path: 'pass', component: PasswordComponent },
  { path: 'joia', component: JoiaComponent },
  { path: 'acessories', component: AcessoriosComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
